import { deepMerge } from 'js/utils/Utils'
import { Clock } from 'three'

import { clamp, floorEx } from 'js/utils/Maths'
import BaseStage from 'js/webgl/base/BaseStage'

import Common from 'js/_core/Common'

const defaults = {
  instanceName: 'BaseWebgl',
  $name: {
    canvas: '[data-gl]',
    canvasContainer: '[data-gl-container]',
  },
  adjuster: {
    timeDelta: {
      digit: 10000,
      max: 0.019,
      min: 0.015,
    },
  },
}

export default class BaseWebgl {
  constructor(options = {}) {
    this.time = new Clock()
    this.timeDelta = 0

    this.$wrapper = document
    this.$canvas = null
    this.$canvasContainer = null

    deepMerge(this, defaults, options)
  }

  init() {
    this._set$()
    this._setStage()
    this.addHandlers()
  }

  destroy() {
    this.removeHandlers()
    this.stage.destroy()
  }

  _set$() {
    this.$canvasContainer = this.$wrapper.querySelector(this.$name.canvasContainer) || null
    if (this.$canvasContainer) {
      this.$canvas = this.$canvasContainer.querySelector(this.$name.canvas) || null
    } else {
      this.$canvas = this.$wrapper.querySelector(this.$name.canvas) || null
    }
  }

  _setStage() {
    if (this.$canvas) {
      this.stage = new BaseStage({
        $canvasContainer: this.$canvasContainer,
        $canvas: this.$canvas,
      })

      this.stage.init()
    }
  }

  addHandlers() {
    if (Common.raf) {
      Common.raf.addHandler(this.onRaf.bind(this), this.instanceName)
    }

    if (Common.resize) {
      Common.resize.addHandler(this.onResize.bind(this), this.instanceName)
    }
  }

  removeHandlers() {
    if (Common.raf) {
      Common.raf.removeHandler(this.instanceName)
    }

    if (Common.resize) {
      Common.resize.removeHandler(this.instanceName)
    }
  }

  onResize() {
    const moduleList = [this.stage]

    moduleList.forEach((moduleListItem) => {
      if (moduleListItem) {
        moduleListItem.onResize()
      }
    })
  }

  onRaf(timeStamp) {
    this.calcTime()
    if (this.stage) {
      this.stage.onRaf(timeStamp)
    }
  }

  calcTime() {
    this.timeDelta = this.time.getDelta()
    this.timeDelta = floorEx(this.timeDelta, this.adjuster.timeDelta.digit)
    this.timeDelta = clamp(this.timeDelta, this.adjuster.timeDelta.min, this.adjuster.timeDelta.max)
  }

  stop() {
    this.canUpdate = false
    this.canUpdateMesh = false
    this.canResize = false
  }

  restart() {
    this.canUpdateMesh = true
    this.canUpdate = true
    this.canResize = true
  }

  clear() {
    this.stop()
  }
}